import React from 'react'
import { AiOutlineClose } from 'react-icons/ai';
import './TravelAdd.min.css'


interface Props {
  addTravel: boolean;
  setAddTravel: React.Dispatch<React.SetStateAction<boolean>>;
  city: string;
  setCity: React.Dispatch<React.SetStateAction<string>>;
  date: string;
  dateEnd: string;
  setDate: React.Dispatch<React.SetStateAction<string>>;
  setDateEnd: React.Dispatch<React.SetStateAction<string>>;
  handleAdd: (e: React.FormEvent) => void;
}


const TravelAdd: React.FC<Props> = ({ addTravel, setAddTravel, city, setCity, date, setDate, dateEnd, setDateEnd, handleAdd }) => {
  const close = () => {
    setAddTravel(false);
    setCity('');
  }


  return (
    <div>
      {addTravel ?
        (
          <form className='addTravels' onSubmit={(e) => { handleAdd(e) }}>
            <span className='icon' id='close' onClick={() => close()} ><AiOutlineClose /></span>
            <p>Dodaj wyjazd</p>
            <div className='city'>
              <label htmlFor="city">Gdzie: </label>
              <input type="input"
                id='city'
                value={city}
                onChange={(e) => setCity(e.target.value)}
              ></input>
            </div>
            <div className='date'>
              <label htmlFor="date">Kiedy: </label>
              <input type='date'
                value={date}
                id='dateStart'
                onChange={(e) => setDate(e.target.value)}
              ></input>
              <input type='date'
                value={dateEnd}
                id='dateEnd'
                onChange={(e) => setDateEnd(e.target.value)}
              ></input>
            </div>
            <button type='submit'>OK</button>
          </form>
        ) : (
          <div></div>
        )}
    </div>
  )
}

export default TravelAdd